<div class="flex flex-col flex-auto overflow-y-auto p-5 pt-0">
  @if (loading) {
    <app-loader></app-loader>
  } @else {
    <ion-content scroll-y="true" #scrollArea>
      @if (!upgradeTariff) {
        <ion-list>
          @for (transcript of transcripts; track transcript.id; let ind = $index; let last = $last; let first = $first) {
            <app-date-line [first]="first" [lastDate]="transcripts[ind - 1]?.createDate" [currentDate]="transcript.createDate"></app-date-line>
            <ion-item-sliding>
              <ion-item>
                <ion-label>
                  <div class="flex mb-2">
                    <div class="flex-auto cursor-pointer" (click)="showTranscript(transcript)">
                      <div class="line-clamp-2 title text-2xl">{{ transcript.title }}</div>
                      <div class="flex items-center text-gray-400 text-sm mt-1">
                        <div class="pr-2.5 mr-2.5 border-r border-r-gray-300 flex items-center whitespace-nowrap">
                          <i class="fa-regular fa-calendar text-gray-400 fa-sm"></i>
                          <div>{{ transcript?.createDate | prettyDate | async }}</div>
                        </div>
                        <div class="flex items-center flex-auto overflow-hidden">
                          <app-initials-avatar [avatarId]="transcript?.user?.avatarId" [user]="{name: transcript?.user?.name}" [width]="20"
                                               [textSize]="'text-[8px]'"></app-initials-avatar>
                          <div class="ltr:ml-2 rtl:mr-2 flex w-full overflow-hidden">
                            <div class="text-gray-400 truncate">{{ transcript?.user?.name }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ion-label>
              </ion-item>
              <ion-item-options>
                <ion-item-option color="danger" (click)="deleteTranscript(transcript)" [disabled]="loading">{{ 'button.delete' | transloco }}</ion-item-option>
              </ion-item-options>
            </ion-item-sliding>
            @if (!last && (transcripts[ind + 1]?.createDate | utcDate: 'd') === (transcript.createDate | utcDate: 'd')) {
              <div class="flex w-full h-[1px] mb-2 mt-2">
                <div class="flex-auto border-b border-b-gray-300">&nbsp;</div>
              </div>
            }
          } @empty {
            <div class="flex flex-col justify-center mt-5 items-center">
              <ion-icon name="search-outline" class="text-6xl"></ion-icon>
              <div class="title text-2xl mt-2.5">{{ 'title.no.protocol.history' | transloco }}</div>
              <div class="mt-2.5 text-center text-base">{{ 'text.no.protocol.history' | transloco }}</div>
            </div>
          }
        </ion-list>
      } @else {
        <div class="mb-1">{{ 'text.tariff.upgrade.message' | transloco }}</div>
        <div class="blurred">
          <div class="font-bold mt-5 blank-text">&nbsp;</div>
          <div class="font-bold mt-5 blank-text">&nbsp;</div>
          <div class="font-bold mt-5 blank-text">&nbsp;</div>
          <div class="mb-2">&nbsp;</div>
        </div>

      }
      <ion-infinite-scroll position="top" (ionInfinite)="loadMoreData($event)" [disabled]="empty">
        <ion-infinite-scroll-content loadingSpinner="bubbles"></ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-content>
  }
</div>
